import {Vue} from '../../addiesaas'
import Router from 'vue-router'
import {sync} from 'vuex-router-sync'

import store from '../vuexstore'
import routes from './resolve'
import guards from './guards'
import globalGuards from './guards/global'
import scrollBehavior from './scroll'
import initAxios from '../axios'

Vue.use(Router)

const guardedRoutes = guards(routes, store)

const router = make(guardedRoutes)

sync(store, router)

initAxios(router, store)

router.push = to => {
  const path = router.match(to).fullPath;
  window.location.assign(path);
}

function make(routes, options) {
  const router = new Router({
    routes,
    scrollBehavior,
    mode: 'abstract',
    ...options || {}
  })

  _.forOwn(globalGuards, (maker, key) => {
    const guard = maker(router, store)
    router[key](guard)
  })

  return router
}

export { routes, guards, make }

export function makeRouter(options) {
  return make(routes, options)
}

export default router
